import dayjs from "dayjs"
import jsPDF from "jspdf"
import ExcelJS from "exceljs"
import saveAs from "file-saver"

function stripHtml(html, separator = "\n") {
  const tmp = document.createElement("DIV")
  tmp.innerHTML = String(html ?? "").replace(/<br\s*\/?\s*>|<\/(?:div|p|li)>/gi, "\n")
  return (tmp.textContent || "").split(/\n+/).map(line => line.trim()).filter(Boolean).join(separator)
}

export const downloadPdf = (panel, semester, year, levelId = 1) => {
  const isGraduate = Number(levelId) > 1
  const doc = new jsPDF({
    unit: "pt",
    format: "a4",
    orientation: "landscape",
  })

  let totalPagesExp = '{total_pages_count_string}'

  doc.setFont("THSarabunNew")
  const centerPoint = doc.internal.pageSize.getWidth() / 2
  doc.setFontSize(12)
  const heading = isGraduate
    ? `ระดับบัณฑิตศึกษา ภาควิชา${panel.department_name_th || ''}\n${panel.curriculum_name_th || ''}`
    : `ภาควิชา${panel.department_name_th} สาขาวิชา${panel.curriculum_name_th} ชั้นปีที่ ${panel.class}`
  const headingLines = isGraduate ? doc.splitTextToSize(heading, doc.internal.pageSize.getWidth() - 50) : heading
  const tableTop = isGraduate ? 140 + Math.max(0, headingLines.length - 1) * 14 : 140

  const dataBody = []
  panel.teachtable.map(section => {
    dataBody.push([section.subject_type_name_th])
    section.data.map(data => {
      let lect_or_prac_txt = ''
      if (data.lect_or_prac === 'ท')
        lect_or_prac_txt = '(ทฤษฎี)'
      else if (data.lect_or_prac === 'ป')
        lect_or_prac_txt = '(ปฏิบัติ)'
      const dataRow = []
      const str = data.subject_id + ' '
        + data.subject_name_en + ' '
        + (data.credit_str ? data.credit_str : '')
      dataRow.push(str)
      dataRow.push((data.section ? data.section : '') + ' ' + lect_or_prac_txt)
      // dataRow.push('') // ห้อง เอาออกไป
      dataRow.push(stripHtml(data.classdatetime_table))
      dataRow.push(data.classroom)
      dataRow.push(data.classbuilding)
      dataRow.push(stripHtml(data.teacher_list_th))
      if (data.midterm_time_formatted) {
        dataRow.push(data.midterm_date_formatted + '\n' + data.midterm_time_formatted)
      }else {
        dataRow.push(data.midterm_date_formatted)
      }
      if (data.final_time_formatted) {
        dataRow.push(data.final_date_formatted + '\n' + data.final_time_formatted)
      }else {
        dataRow.push(data.final_date_formatted)
      }
      dataRow.push(stripHtml(data.rules_th, ' '))
      dataRow.push(stripHtml(data.remark))
      dataRow.push(data.limit)

      dataBody.push(dataRow)
    })
  })

  // ====================================
  doc.autoTable({
    head: [
      [
        {
          content: "รหัสวิชา - ชื่อวิชา - หน่วยกิต(ทฤษฎี-ปฏิบัติ)",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ตารางเรียน",
          rowSpan: 1,
          colSpan: 5,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ตารางสอบ",
          rowSpan: 1,
          colSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "เงื่อนไข",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "หมายเหตุ",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "รับ",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
      ],
      [
        {
          content: "กลุ่ม",
          styles: { halign: "center", valign: "middle" },
        },
        // {
        //   content: "ห้อง",
        //   styles: { halign: "center", valign: "middle" },
        // },
        {
          content: "วัน-เวลาเรียน",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ห้องเรียน",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ตึก",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "อาจารย์ผู้สอน",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "กลางภาค",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ปลายภาค",
          styles: { halign: "center", valign: "middle" },
        },
      ],
    ],
    body: dataBody,
    theme: "plain",
    styles: {
      font: "THSarabunNew",
      fontStyle: "normal",
      fontSize: 12,
      lineColor: [44, 62, 80],
      lineWidth: 1,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 12,
      lineColor: [0, 0, 0],
      lineWidth: 1,
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 1,
    didDrawPage: function () {
      // Header
      var img = new Image()
      img.src = 'black_logo.png'
      doc.addImage(img, 'png', centerPoint - 40, 10, 80, 80)

      doc.setFontSize(12)
      doc.text("ประกาศ คณะ" + panel.faculty_name_th, centerPoint, 100, {  // + 110
        align: "center",
      })
      doc.text(
        `เรื่อง ตารางเรียน - ตารางสอบ ประจำภาคเรียนที่ ${semester} ปีการศึกษา ${year}`,
        centerPoint,
        115,
        { align: "center" }
      )
      doc.text(
        headingLines,
        centerPoint,
        130,
        { align: "center" }
      )

      // Footer
      var pageStr = "หน้า " + doc.internal.getNumberOfPages() + " / " + totalPagesExp
      doc.text(
        pageStr,
        doc.internal.pageSize.getWidth() - 80,
        30
      )
    },
    margin: { top: tableTop, bottom: 50, left: 25, right: 25 },
    columnStyles: {
      0: { cellWidth: 100 },
      2: { cellWidth: 60 },
      3: { cellWidth: 50 },
      6: { cellWidth: 50 },
      7: { cellWidth: 50 },
      9: { cellWidth: 100 },
      10: { cellWidth: 25 },
    }
  })

  doc.putTotalPages(totalPagesExp)

  doc.setFontSize(11)
  doc.text("ประกาศ ณ วันที่           เดือน                        พ.ศ.", 40, doc.internal.pageSize.getHeight() - 53)
  doc.text(" .........................................................................................................", 40, doc.internal.pageSize.getHeight() - 33)
  doc.text("(                                                                               )", 40, doc.internal.pageSize.getHeight() - 20)

  const dateText = dayjs().locale('th').format('D MMM BBBB')
  const timeText = dayjs().format('HH:mm')
  doc.text(`พิมพ์เมื่อ: วันที่ ${dateText} เวลา ${timeText} น.`, doc.internal.pageSize.getWidth() - 180, doc.internal.pageSize.getHeight() - 25)

  //=====================================

  doc.autoPrint()
  window.open(doc.output("bloburl"), "_blank")
}

export const downloadExcel = async (panel, semester, year, levelId = 1) => {
  if (Number(levelId) > 1) return downloadGraduateExcel([panel], semester, year, false)
  const dateText = dayjs().locale('th').format('D MMM BBBB')
  const timeText = dayjs().format('HH:mm')

  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  const middle_left_no_wrap = {
    vertical: "middle",
    horizontal: "left"
  }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  const middle_right = {
    vertical: "middle",
    horizontal: "right",
    wrapText: true
  }

  const workbook = new ExcelJS.Workbook()
  // const workbook =  createAndFillWorkbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()

  const worksheet = workbook.addWorksheet("Timetable", {
    // pageSetup: { paperSize: 9, fitToPage: true, fitToHeight: 5, fitToWidth: 100 },
    pageSetup: { paperSize: 9, showGridLines: false },
  })
  // const cell = worksheet.getCell('A1')
  // cell.value = new Date(1968, 5, 1)

  // const row = worksheet.getRow(5)
  // row.addPageBreak()

  // worksheet.getCell('A6').value = 123

  // worksheet.pageSetup.printTitlesRow = '1:3'

  worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

  // A4 : 8.3 * 11.7 inch = 83 117
  // width left = 83 - 1.4 = 81.6
  // height left = 117 - 1.5 - 0.6 = 114.9

  const l_border = 0.7
  const r_border = 0.55
  const t_border = 0.75
  const b_border = 0.55
  const hf_border = 0.3
  // const lenght_new_page = 117 - 51 - 43 - 1.5 //All - numOfLine - random

  worksheet.pageSetup.margins = {
    left: l_border,
    right: r_border,
    top: t_border,
    bottom: b_border,
    header: hf_border,
    footer: hf_border,
  }

  // 82
  // worksheet.getCell("A1").value = 123
  // worksheet.getCell("B1").value = 456

  // worksheet.getCell("A2").value = 123
  // worksheet.getCell("B2").value = 456

  // const col1 = worksheet.getColumn(1)
  // col1.width = 70

  // const col2 = worksheet.getColumn(2)
  // col2.width = 11.6
  worksheet.getColumn(1).width = 10
  worksheet.getColumn(2).width = 45
  worksheet.getColumn(3).width = 10
  worksheet.getColumn(4).width = 15
  worksheet.getColumn(5).width = 10
  worksheet.getColumn(6).width = 18
  worksheet.getColumn(7).width = 15
  worksheet.getColumn(8).width = 15
  worksheet.getColumn(9).width = 30
  worksheet.getColumn(10).width = 30
  worksheet.getColumn(11).width = 30
  worksheet.getColumn(12).width = 30
  worksheet.getColumn(13).width = 30
  worksheet.getColumn(14).width = 7

  const dataBody = []
  panel.teachtable.map(section => {
    dataBody.push([section.subject_type_name_th])
    section.data.map(data => {
      let lect_or_prac_txt = ''
      if (data.lect_or_prac === 'ท')
        lect_or_prac_txt = '(ทฤษฎี)'
      else if (data.lect_or_prac === 'ป')
        lect_or_prac_txt = '(ปฏิบัติ)'
      const dataRow = []
      dataRow.push(data.subject_id)
      dataRow.push(data.subject_name_en)
      dataRow.push(data.credit_str ? data.credit_str : '')
      dataRow.push((data.section ? data.section : '') + ' ' + lect_or_prac_txt)
      dataRow.push(data.sec_pair)
      dataRow.push(stripHtml(data.classdatetime_table))
      dataRow.push(data.classroom)
      dataRow.push(data.classbuilding)
      dataRow.push(stripHtml(data.teacher_list_th))
      if (data.midterm_time_formatted) {
        dataRow.push(data.midterm_date_formatted + '\n' + data.midterm_time_formatted)
      }else {
        dataRow.push(data.midterm_date_formatted)
      }
      if (data.final_time_formatted) {
        dataRow.push(data.final_date_formatted + '\n' + data.final_time_formatted)
      }else {
        dataRow.push(data.final_date_formatted)
      }
      dataRow.push(stripHtml(data.rules_th, ' '))
      dataRow.push(stripHtml(data.remark))
      dataRow.push(data.limit)

      dataBody.push(dataRow)
    })
  })

  let row_num = 1
  let column_num = 1

  // เริ่มวาดหัวข้อ-------------------------------------------------
  worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  worksheet.getCell("A" + String(row_num)).alignment = middle_center
  worksheet.getCell("A" + String(row_num++)).value = `ตารางเรียน - ตารางสอบ ประจำภาคเรียนที่ ${semester} ปีการศึกษา ${year}`

  worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  worksheet.getCell("A" + String(row_num)).alignment = middle_center
  worksheet.getCell("A" + String(row_num++)).value = `คณะ${panel.faculty_name_th}`

  worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  worksheet.getCell("A" + String(row_num)).alignment = middle_center
  worksheet.getCell("A" + String(row_num++)).value = `สาขาวิชา${panel.curriculum_name_th} ชั้นปีที่ ${panel.class}`

  worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  worksheet.getCell("A" + String(row_num)).alignment = middle_center
  worksheet.getCell("A" + String(row_num++)).value = ''

  // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "รหัสวิชา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ชื่อวิชา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "หน่วยกิต"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "กลุ่มเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "กลุ่มจับคู่"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ห้องเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ตึก"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "อาจารย์ผู้สอน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาสอบกลางภาค"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาสอบปลายภาค"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "เงื่อนไข"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "หมายเหตุ"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "รับ"
  column_num++

  row_num++
  column_num = 1
  dataBody.map((data) => {
    // เริ่มวาดข้อมูล-------------------------------------------------
    worksheet.getRow(row_num).getCell(column_num).alignment = middle_left_no_wrap
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[0]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[1]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[2]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[3]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[4]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[5]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[6]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[7]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[8]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[9]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[10]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[11]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[12]

    worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
    worksheet.getRow(row_num).getCell(column_num).border = common_format
    worksheet.getRow(row_num).getCell(column_num++).value = data[13]

    row_num++
    // -------------------------------------------------

    //   if ((index + 1) % lenght_new_page === 0) {
    //     worksheet.mergeCells("A" + String(row_num) + ":J" + String(row_num))
    //     worksheet.getCell("A" + String(row_num)).alignment = {
    //       vertical: "middle",
    //       horizontal: "right",
    //     }
    //     worksheet.getCell("A" + String(row_num++)).value = `พิมพ์เมื่อ: วันที่ ${dateText} เวลา ${timeText} น.`
    //     new_page = true
    //     const row = worksheet.getRow(row_num++)
    //     row.addPageBreak()
    //   }
    //   column_num = 1
    // })

    column_num = 1
  })

  worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  worksheet.getCell("A" + String(row_num)).alignment = middle_right
  worksheet.getCell("A" + String(row_num++)).value = `พิมพ์เมื่อ: วันที่ ${dateText} เวลา ${timeText} น.`

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })
  saveAs(blob, `${panel.faculty_name_en}-${panel.curriculum_name_en}-class${panel.class}-${semester}-${year}` + fileExtension)
}

export const downloadExcelAll = async (teach_table, semester, year, levelId = 1) => {
  if (Number(levelId) > 1) return downloadGraduateExcel(teach_table, semester, year, true)
  // const dateText = dayjs().locale('th').format('D MMM BBBB')
  // const timeText = dayjs().format('HH:mm')

  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  // const middle_left_no_wrap = {
  //   vertical: "middle",
  //   horizontal: "left"
  // }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  // const middle_right = {
  //   vertical: "middle",
  //   horizontal: "right",
  //   wrapText: true
  // }

  const workbook = new ExcelJS.Workbook()
  // const workbook =  createAndFillWorkbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()

  const worksheet = workbook.addWorksheet('Timetable', {
    // pageSetup: { paperSize: 9, fitToPage: true, fitToHeight: 5, fitToWidth: 100 },
    pageSetup: { paperSize: 9, showGridLines: false },
  })
  // const cell = worksheet.getCell('A1')
  // cell.value = new Date(1968, 5, 1)

  // const row = worksheet.getRow(5)
  // row.addPageBreak()

  // worksheet.getCell('A6').value = 123

  // worksheet.pageSetup.printTitlesRow = '1:3'

  worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

  // A4 : 8.3 * 11.7 inch = 83 117
  // width left = 83 - 1.4 = 81.6
  // height left = 117 - 1.5 - 0.6 = 114.9

  const l_border = 0.7
  const r_border = 0.55
  const t_border = 0.75
  const b_border = 0.55
  const hf_border = 0.3
  // const lenght_new_page = 117 - 51 - 43 - 1.5 //All - numOfLine - random

  worksheet.pageSetup.margins = {
    left: l_border,
    right: r_border,
    top: t_border,
    bottom: b_border,
    header: hf_border,
    footer: hf_border,
  }

  // 82
  // worksheet.getCell("A1").value = 123
  // worksheet.getCell("B1").value = 456

  // worksheet.getCell("A2").value = 123
  // worksheet.getCell("B2").value = 456

  // const col1 = worksheet.getColumn(1)
  // col1.width = 70

  // const col2 = worksheet.getColumn(2)
  // col2.width = 11.6

  let row_num = 1
  let column_num = 1

  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 20
  worksheet.getColumn(column_num++).width = 20
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 5
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 45
  worksheet.getColumn(column_num++).width = 45
  worksheet.getColumn(column_num++).width = 7
  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 10
  worksheet.getColumn(column_num++).width = 18
  worksheet.getColumn(column_num++).width = 15
  worksheet.getColumn(column_num++).width = 15
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 30
  worksheet.getColumn(column_num++).width = 7
  worksheet.getColumn(column_num++).width = 7
  column_num = 1

  // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ภาคการศึกษา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "คณะ"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ภาควิชา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "หลักสูตร"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ชั้นปี"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "กลุ่มวิชา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "รหัสวิชา"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ชื่อวิชาภาษาไทย"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ชื่อวิชาภาษาอังกฤษ"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "หน่วยกิต"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "(L-P-S)"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ประเภท"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "กลุ่มเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "กลุ่มจับคู่"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ห้องเรียน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ตึก"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "อาจารย์ผู้สอน"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาสอบกลางภาค"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "วัน-เวลาสอบปลายภาค"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "เงื่อนไข"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "หมายเหตุ"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "รับ"
  column_num++

  worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
  worksheet.getRow(row_num).getCell(column_num).border = common_format
  worksheet.getRow(row_num).getCell(column_num).value = "ลง"
  column_num++

  row_num++
  column_num = 1

  teach_table.map(panel => {
    panel.teachtable.map(section => {
      section.data.map(data => {
        // เริ่มวาดข้อมูล-------------------------------------------------

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = `${semester}/${year}`

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = panel.faculty_name_th

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = panel.department_name_th

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = panel.curriculum_name_th

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = panel.class

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = section.subject_type_name_th

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.subject_id

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.subject_name_th

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.subject_name_en

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.credit

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.credit_lps

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.lect_or_prac === 'ท' ? 'ทฤษฎี' : data.lect_or_prac === 'ป' ? 'ปฏิบัติ' : ''

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.section

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.sec_pair

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = stripHtml(data.classdatetime_table)

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.classroom

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.classbuilding

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = stripHtml(data.teacher_list_th)

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        if (data.midterm_time_formatted) {
          worksheet.getRow(row_num).getCell(column_num++).value = data.midterm_date_formatted + '\n' + data.midterm_time_formatted
        } else {
          worksheet.getRow(row_num).getCell(column_num++).value = data.midterm_date_formatted
        }

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        if (data.final_time_formatted) {
          worksheet.getRow(row_num).getCell(column_num++).value = data.final_date_formatted + '\n' + data.final_time_formatted
        } else {
          worksheet.getRow(row_num).getCell(column_num++).value = data.final_date_formatted
        }

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = stripHtml(data.rules_th, ' ')

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = stripHtml(data.remark)

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.limit

        worksheet.getRow(row_num).getCell(column_num).alignment = middle_center
        worksheet.getRow(row_num).getCell(column_num).border = common_format
        worksheet.getRow(row_num).getCell(column_num++).value = data.count

        row_num++
        // -------------------------------------------------

        //   if ((index + 1) % lenght_new_page === 0) {
        //     worksheet.mergeCells("A" + String(row_num) + ":J" + String(row_num))
        //     worksheet.getCell("A" + String(row_num)).alignment = {
        //       vertical: "middle",
        //       horizontal: "right",
        //     }
        //     worksheet.getCell("A" + String(row_num++)).value = `พิมพ์เมื่อ: วันที่ ${dateText} เวลา ${timeText} น.`
        //     new_page = true
        //     const row = worksheet.getRow(row_num++)
        //     row.addPageBreak()
        //   }
        //   column_num = 1
        // })

        column_num = 1
      })
    })
  })

  // worksheet.mergeCells("A" + String(row_num) + ":N" + String(row_num))
  // worksheet.getCell("A" + String(row_num)).alignment = middle_right
  // worksheet.getCell("A" + String(row_num++)).value = `พิมพ์เมื่อ: วันที่ ${dateText} เวลา ${timeText} น.`

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })
  saveAs(blob, `Timetable-${semester}-${year}` + fileExtension)
}

// Graduate exports share one schema for panel and all-panel downloads.
// The display title comes from the same mapping as the screen, including
// branch/admission labels and wildcard descriptions. No undergraduate class/pair columns.
async function downloadGraduateExcel(panels, semester, year, allPanels) {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()
  const sheet = workbook.addWorksheet("Graduate Timetable", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
  })
  const columns = [
    ["ภาคการศึกษา", 14], ["คณะ", 25], ["ภาควิชา", 25],
    ["สาขา / แขนง / ประเภทการรับเข้า / ภาคเรียนที่เข้า", 65],
    ["กลุ่มวิชา", 25], ["รหัสวิชา", 14], ["ชื่อวิชาภาษาไทย", 35],
    ["ชื่อวิชาภาษาอังกฤษ", 35], ["หน่วยกิต", 12], ["(L-P-S)", 14],
    ["ประเภท", 14], ["กลุ่มเรียน", 12], ["วัน-เวลาเรียน", 28],
    ["ห้องเรียน", 18], ["ตึก", 22], ["อาจารย์ผู้สอน", 32],
    ["วัน-เวลาสอบกลางภาค", 30], ["วัน-เวลาสอบปลายภาค", 30],
    ["เงื่อนไข", 40], ["หมายเหตุ", 35], ["รับ", 10], ["ลง", 10],
  ]
  columns.forEach(([, width], i) => { sheet.getColumn(i + 1).width = width })
  const title = sheet.addRow([`ตารางเรียน - ตารางสอบ ระดับบัณฑิตศึกษา ${semester}/${year}`])
  sheet.mergeCells(title.number, 1, title.number, columns.length)
  title.height = 28
  title.font = { bold: true, size: 14 }
  const header = sheet.addRow(columns.map(([name]) => name))
  header.font = { bold: true }
  header.height = 45
  const examText = (row, type) => [row[`${type}_date_formatted`], row[`${type}_time_formatted`]].filter(Boolean).join("\n")
  panels.forEach(panel => (panel.teachtable || []).forEach(group => (group.data || []).forEach(row => {
    sheet.addRow([
      `${semester}/${year}`, panel.faculty_name_th || "", panel.department_name_th || "",
      panel.curriculum_name_th || "", group.subject_type_name_th || "", row.subject_id,
      row.subject_name_th || "", row.subject_name_en || "", row.credit ?? "", row.credit_lps || "",
      row.lect_or_prac === "ท" ? "ทฤษฎี" : row.lect_or_prac === "ป" ? "ปฏิบัติ" : "",
      row.section, stripHtml(row.classdatetime_table), row.classroom || "", row.classbuilding || "",
      stripHtml(row.teacher_list_th), examText(row, "midterm"), examText(row, "final"),
      stripHtml(row.rules_th), stripHtml(row.remark), row.limit, row.count,
    ])
  })))
  sheet.eachRow(row => row.eachCell({ includeEmpty: true }, cell => {
    cell.alignment = { vertical: "middle", wrapText: true }
    if (row.number > 1) cell.border = {
      top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" },
    }
  }))
  sheet.views = [{ state: "frozen", ySplit: 2 }]
  sheet.pageSetup.printTitlesRow = "1:2"
  sheet.headerFooter.oddFooter = "หน้า &P จาก &N"
  const buffer = await workbook.xlsx.writeBuffer()
  const panel = panels[0] || {}
  const scope = allPanels ? "All" : [panel.faculty_id, panel.department_id, panel.curriculum2_id,
    panel.branch_id, panel.admission_type, panel.admission_semester].map(value => String(value ?? "").replace(/[^a-zA-Z0-9_-]/g, "_")).join("-")
  saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    `Graduate-Timetable-${scope}-${semester}-${year}.xlsx`)
}
